import { ColumnFiltersState } from "@cayo/shared/components/GridContainer/types/columnFilters";
import { getSearchTextFromValue } from "../getSearchTextFromValue";

export const matchesColumnFilters = <TItem extends Record<string, unknown>>(
  item: TItem,
  activeColumnFilters: ColumnFiltersState
): boolean => {
  return Object.entries(activeColumnFilters).every(([fieldName, filterValue]) => {
    const itemValue = getSearchTextFromValue(item[fieldName as keyof TItem]);

    const normalizedItemValue = itemValue.toLocaleLowerCase();
    const normalizedFilterValue = filterValue.toLocaleLowerCase();

    return normalizedItemValue.includes(normalizedFilterValue);
  });
};
